import axios from "axios";
import {ordersServicesPath} from "../../../../Constants";
import ObjectUtil from "../../../../utils/common/ObjectUtil";

const materialOrganizationOptionRestUrl = ordersServicesPath + '/organizations/material-organization-options'

export default class MaterialOrganizationOptionService {

    static async setGroup(groupId, data) {
        return axios.patch(materialOrganizationOptionRestUrl + '/set-group?groupId=' + groupId, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getWithGroupMaterialAndDefaultSupplierById(id) {
        return axios.get(materialOrganizationOptionRestUrl + '/' + id + '/with-group-material-and-default-supplier');
    }

    static async getAllWithGroupMaterialAndUnit() {
        return axios.get(materialOrganizationOptionRestUrl + '/with-group-material-unit');
    }

    static async save(queryStringData, data) {
        const queryString = Object.entries(queryStringData).map(([key, value], i) => `${key}=${value}`).join("&")
        return await axios.post(materialOrganizationOptionRestUrl + "?" + queryString, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async saveByMaterial(queryStringData) {
        const queryString = Object.entries(queryStringData).map(([key, value], i) => `${key}=${value}`).join("&")
        return await axios.post(materialOrganizationOptionRestUrl + "/by-material?" + queryString, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async addSigJobInMaterialsByMaterialGroup(dataSignJob, dataMaterialGroupIds) {
        let data = ObjectUtil.createRequestTwoObjectIds(dataSignJob, dataMaterialGroupIds);
        return await axios.put(materialOrganizationOptionRestUrl + '/add-sig-job-in-materials-by-material-group', JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async createByMaterial(materialId, groupMaterialId) {
        return await axios.post(materialOrganizationOptionRestUrl + '/by-material' + '?materialId=' + materialId + "&groupMaterialId=" + groupMaterialId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getChoiceSlabMaterial(materialId, supplierId) {
        return axios.get(materialOrganizationOptionRestUrl
            + '/get-choice-slab-material' + "?materialId=" + materialId + "&supplierId=" + supplierId);
    }

    static async getWithDefaultSupplier(nameMaterial) {
        return axios.get(materialOrganizationOptionRestUrl + '/with-default-supplier' + "?nameMaterial="
            + nameMaterial);
    }

    static async getWithDefaultSupplierById(id) {
        return axios.get(materialOrganizationOptionRestUrl + '/with-default-supplier-by-id?id=' + id);
    }

    static async getWithFilter(typeMaterial, unitId, groupMaterialId, manufacturerId) {
        return axios.get(materialOrganizationOptionRestUrl + '/with-filter'
            + "?typeMaterial=" + typeMaterial + "&unitId=" + unitId
            + "&groupMaterialId=" + groupMaterialId + "&manufacturerId=" + manufacturerId
        );
    }

    static async getForCloudCatalog(materialId) {
        return axios.get(materialOrganizationOptionRestUrl + '/for-cloud-catalog'
            + "?materialId=" + materialId);
    }

    static async updateCurrentOptions(data, supplierId, manufacturerId, groupMaterialId) {
        return await axios.put(materialOrganizationOptionRestUrl + '/' + data.id + "?defaultSupplierId="
            + supplierId + "&groupMaterialId=" + groupMaterialId + `&manufacturerId=${manufacturerId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllFilter(group, page, pageSize, sort,
                              typeMaterial, subTypeMaterial, search, archive, supplierId) {
        const groupId = (group && typeof group.id === 'number') ? group.id : null;

        const params = {
            groupMaterialId: groupId,
            page: page,
            pageSize: pageSize,
            sort: sort,
            typeMaterial: typeMaterial,
            subTypeMaterial: subTypeMaterial,
            search: search,
            archive: archive, supplierId: supplierId
        };

        const queryString = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');

        const url = `${materialOrganizationOptionRestUrl}/filter?${queryString}`;

        return axios.get(url);
    }

    static async deleteJobMetric(materialId, data) {
        return axios.patch(`${materialOrganizationOptionRestUrl}/delete-job-metric-organization?materialId=${materialId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async bindMaterial(id, materialId) {
        return axios.patch(`${materialOrganizationOptionRestUrl}/${id}/set-id-material?materialId=${materialId}`, JSON.stringify({}), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async addJobMetric(materialId, data) {
        return axios.patch(`${materialOrganizationOptionRestUrl}/add-job-metric-organization?materialId=${materialId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async deleteJobMetricByMaterialGroup(data) {
        return axios.patch(`${materialOrganizationOptionRestUrl}/delete-job-metric-organization-in-materials-by-material-group`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async addJobMetricByMaterialGroup(data) {
        return axios.put(`${materialOrganizationOptionRestUrl}/add-job-metric-organization-in-materials-by-material-group`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async deleteJobMetricByMaterialIds(data) {
        return axios.patch(`${materialOrganizationOptionRestUrl}/delete-job-metric-organization-in-materials-by-material-ids`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async addJobMetricByMaterialIds(data) {
        return axios.put(`${materialOrganizationOptionRestUrl}/add-job-metric-organization-in-materials-by-material-ids`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setDefaultMargin(margin, data) {
        return axios.patch(`${materialOrganizationOptionRestUrl}/set-default-margin?margin=${margin}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setDefaultName(data) {
        return axios.patch(`${materialOrganizationOptionRestUrl}/set-default-name`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async deleteMaterial(data) {
        return axios.patch(`${materialOrganizationOptionRestUrl}/delete-by-ids`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setCut(cut, data) {
        return axios.patch(`${materialOrganizationOptionRestUrl}/set-cut-by-ids?cut=${cut}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }


}
